var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackingIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 515,
    viewBox: "0 0 480 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.344 66.9009C270.201 66.6371 270.192 66.3025 270.318 65.9976C272.398 61.7201 274.063 58.3249 273.907 52.9047C273.55 40.4583 262.766 30.7487 250.085 31.6735C238.757 32.527 229.81 41.9193 229.624 53.142C229.409 65.7384 239.83 75.7931 252.426 75.4398C252.934 75.4256 253.407 75.3789 253.914 75.3312L273.673 74.2413C273.91 74.2346 274.071 73.9622 273.964 73.7643L270.344 66.9009Z",
    fill: "url(#paint0_linear_130_17414)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.875 53.3937C258.762 49.4456 255.317 46.3276 251.261 46.6758C247.71 46.9428 244.881 49.9018 244.812 53.3862C244.724 57.4069 248.036 60.629 252.031 60.517C252.302 60.5094 255.852 60.209 256.764 60.1164C256.899 60.1126 256.998 60.0094 257.063 59.9071L258.379 56.1868C258.727 55.3065 258.903 54.364 258.875 53.3937Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_17414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.568 162.35C248.568 162.35 300.246 165.493 313.009 129.345C325.771 93.1971 395.966 56.2619 429.802 117.556C463.638 178.85 381.291 259.792 427.227 309.297C473.163 358.801 498.689 451.526 362.787 481.382C226.885 511.238 105.669 391.019 79.4986 273.929C53.3282 156.839 91.6337 88.48 139.476 81.4079C187.318 74.3358 183.506 161.549 248.568 162.35Z",
    fill: "url(#paint1_linear_130_17414)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.97 393.763C152.97 393.763 168.964 398.77 168.702 415.782C168.441 432.793 65.9299 412.9 26.8437 326.121C-12.2424 239.343 37.0909 251.921 47.0544 268.966C57.0178 286.012 91.915 363.35 152.97 393.763Z",
    fill: "url(#paint2_linear_130_17414)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.534 414.48C339.666 414.48 407.868 407.125 407.868 398.052C407.868 388.979 339.666 381.624 255.534 381.624C171.403 381.624 103.201 388.979 103.201 398.052C103.201 407.125 171.403 414.48 255.534 414.48Z",
    fill: "#42307D",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.959 323.023C211.959 323.023 205.884 321.354 196.471 319.418C193.039 325.838 184.611 331.657 169.997 335.339C121.186 347.645 127.879 389.763 127.89 389.858C195.242 411.337 336.544 382.231 356.438 398.842C381.905 420.137 276.262 307.569 211.959 323.023Z",
    fill: "#F985C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M298.365 363.939C265.197 332.83 202.986 361.074 202.986 361.074C202.986 361.074 159.983 384.217 128.707 373.869C127.546 379.105 127.269 384.498 127.89 389.824C171.343 403.698 245.61 396.5 298.17 394.113C310.843 387.532 313.813 378.431 298.365 363.939Z",
    fill: "#F743AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.959 323.023C211.959 323.023 205.884 321.354 196.471 319.418C193.039 325.838 184.611 331.657 169.997 335.339C121.186 347.645 127.879 389.763 127.89 389.858C195.242 411.337 336.544 382.231 356.437 398.842C381.905 420.137 276.262 307.569 211.959 323.023Z",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.959 323.023C211.959 323.023 205.884 321.354 196.471 319.418C193.039 325.838 184.611 331.657 169.997 335.339C121.186 347.645 127.879 389.763 127.89 389.858C195.242 411.337 336.544 382.231 356.437 398.842C381.905 420.137 276.262 307.569 211.959 323.023Z",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.959 323.023C211.959 323.023 205.884 321.354 196.471 319.418C193.039 325.838 184.611 331.657 169.997 335.339C121.186 347.645 127.879 389.763 127.89 389.858C195.242 411.337 336.544 382.231 356.437 398.842C381.905 420.137 276.262 307.569 211.959 323.023Z",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.997 335.339C184.611 331.64 193.017 325.838 196.471 319.401C162.103 312.369 83.2516 301.972 92.9592 357.419C95.8019 373.674 108.909 383.755 127.89 389.819C127.879 389.763 121.186 347.645 169.997 335.339Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M127.889 389.835C127.269 384.509 127.546 379.116 128.707 373.881C125.227 372.746 121.911 371.16 118.844 369.163C87.7463 348.708 96.091 329.971 107.462 321.593C96.1855 328.041 89.7602 339.161 92.9589 357.436C95.8017 373.691 108.908 383.772 127.889 389.835Z",
    fill: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.997 335.339C184.611 331.64 193.017 325.837 196.471 319.401C162.103 312.369 83.2516 301.972 92.9592 357.419C95.8019 373.674 108.908 383.755 127.89 389.818C127.879 389.763 121.186 347.645 169.997 335.339V335.339Z",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.169 196.285C283.584 198.31 294.176 200.468 294.081 192.602C293.942 181.331 272.135 169.081 229.455 192.602C186.775 216.123 183.281 176.608 215.581 165.259C247.88 153.911 301.875 185.364 318.019 151.268C324.283 135.692 306.192 115.915 272.09 121.617C270.143 121.617 256.898 125.378 254.667 110.346",
    stroke: "#42307D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.391 194.555C272.391 194.555 273.314 194.944 274.777 195.473",
    stroke: "#42307D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.755 336.229C309.379 335.161 301.218 318.717 298.387 310.767C286.821 311.663 279.211 312.992 279.211 312.992C262.299 328.235 219.92 322.806 188.599 324.675C157.279 326.544 127.011 363.327 148.462 350.999C169.913 338.671 183.381 344.535 186.513 347.456C245.398 400.644 314.464 411.592 360.026 401.54C401.342 370.437 354.346 337.637 328.755 336.229Z",
    fill: "#F985C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.755 336.229C309.379 335.161 301.218 318.717 298.387 310.767C286.821 311.663 279.211 312.992 279.211 312.992C262.299 328.235 219.92 322.806 188.599 324.675C157.279 326.544 127.011 363.327 148.462 350.999C169.913 338.671 183.381 344.535 186.513 347.456C245.398 400.644 314.464 411.592 360.026 401.54C401.343 370.437 354.346 337.637 328.755 336.229V336.229Z",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.195 348.49C390.116 309.148 329.724 308.341 298.392 310.767C301.224 318.717 309.385 335.161 328.761 336.229C354.351 337.637 401.37 370.436 360.031 401.528C396.169 393.551 417.514 372.328 407.195 348.49Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M393.632 330.338C393.632 330.405 409.615 367.95 375.458 381.707C373.616 388.177 368.826 394.892 360.003 401.529C396.163 393.551 417.514 372.328 407.167 348.49C404.11 341.48 399.478 335.269 393.632 330.338Z",
    fill: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.195 348.49C390.116 309.148 329.724 308.341 298.392 310.767C301.224 318.717 309.385 335.161 328.761 336.229C354.351 337.637 401.37 370.436 360.031 401.528C396.169 393.551 417.514 372.328 407.195 348.49Z",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.157 209.252C264.157 209.252 307.582 234.931 320.11 279.191C332.638 323.451 303.421 336.841 303.421 336.841C303.421 336.841 178.363 333.687 166.464 318.444C154.564 303.201 208.404 209.652 244.836 204.245C261.442 203.388 264.157 209.252 264.157 209.252Z",
    fill: "#E0CCFC",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.386 248.277C303.928 264.899 306.592 291.363 306.737 292.882C346.124 286.951 370.117 311.857 370.156 311.885C371.63 305.86 371.135 298.534 368.137 289.633C341.406 210.281 264.992 204.245 264.992 204.245C263.323 205.08 257.153 215.31 257.153 215.31",
    fill: "#E0CCFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M253.788 227.733C253.788 227.733 264.535 226.982 266.644 217.38C268.752 207.778 272.207 212.507 272.018 214.943C271.829 217.38 272.891 209.758 272.107 205.286C271.601 204.646 266.644 204.407 266.644 204.407C266.644 204.407 246.422 223.61 253.788 227.733Z",
    fill: "#FFCC71"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M272.107 205.286C272.352 207.283 275.189 233.207 256.119 234.814C256.119 234.814 253.927 234.57 255.251 238.325C256.575 242.08 277.659 232.205 278.977 218.631C280.296 205.058 313.012 223.722 310.503 239.131C307.994 254.541 358.106 266.441 357.478 296.503C357.439 298.312 356.916 300.077 355.965 301.616C365.127 306.689 370.134 311.874 370.145 311.885C371.619 305.86 371.124 298.534 368.126 289.633C346.374 225.029 291.689 209.013 272.107 205.286Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.386 248.277C303.928 264.899 306.592 291.363 306.737 292.882C346.124 286.951 370.117 311.857 370.156 311.885C371.63 305.86 371.135 298.534 368.137 289.633C341.406 210.281 264.992 204.245 264.992 204.245C263.323 205.08 257.153 215.31 257.153 215.31",
    stroke: "#42307D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M306.737 292.882C306.592 291.363 303.927 264.9 293.385 248.277C293.769 248.9 300.484 278.04 279.917 291.97C259.351 305.9 303.916 300.314 306.737 292.882Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.235 324.692C223.235 324.692 358.496 359.572 370.145 311.897C370.145 311.897 346.123 286.963 306.726 292.893V292.966L223.235 324.692Z",
    fill: "#F985C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M355.964 301.6C344.082 321.165 265.386 319.457 233.983 327.19C266.221 334.255 360.504 351.333 370.145 311.875C370.134 311.875 365.127 306.69 355.964 301.6Z",
    fill: "#F743AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.235 324.692C223.235 324.692 358.496 359.572 370.145 311.897C370.145 311.897 346.123 286.963 306.726 292.893V292.966L223.235 324.692Z",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.667 234.881V291.547",
    stroke: "#42307D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.72 190.655C265.72 190.655 271.378 224.895 254.666 227.61C237.955 230.325 246.722 187.317 246.722 187.317L265.72 190.655Z",
    fill: "#F985C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.425 201.72C247.034 203.667 255.668 209.341 266.644 204.407C266.821 199.803 266.511 195.194 265.72 190.655L259.473 189.542C258.138 189.723 256.857 190.184 255.712 190.894C251.178 193.743 247.368 195.245 245.287 196.502C245.148 197.631 244.542 200.452 244.425 201.72H244.425Z",
    fill: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.72 190.655C265.72 190.655 271.378 224.895 254.666 227.61C237.955 230.325 246.722 187.317 246.722 187.317L265.72 190.655Z",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.606 156.403C234.606 156.403 236.236 161.521 231.363 163.746C226.49 165.972 232.058 174.255 235.541 174.461C239.023 174.667 233.176 181.437 239.507 180.881C245.838 180.324 255.306 157.36 247.373 151.725C239.44 146.089 230.289 153.366 234.606 156.403Z",
    fill: "#5E41A7",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.418 157.11C243.418 157.11 226.017 200.908 253.159 202.465C266.8 202.465 276.123 184.791 268.886 158.912C261.648 133.033 243.418 157.11 243.418 157.11Z",
    fill: "#F985C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M268.886 158.912C267.801 155.018 266.466 152.275 264.991 150.389C262.295 148.697 259.253 147.628 256.091 147.263C249.532 149.026 243.407 157.109 243.407 157.109C243.407 157.109 242.85 158.567 242.049 160.948C245.843 161.927 250.689 162.433 254.811 160.486C262.994 156.625 259.629 172.903 265.503 175.356C271.378 177.81 270.376 191.378 259.551 201.03L259.668 200.974C260.302 200.64 260.93 200.279 261.553 199.889C270.154 194.104 274.493 178.972 268.886 158.912Z",
    fill: "#F743AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.418 157.11C243.418 157.11 226.017 200.908 253.159 202.465C266.8 202.465 276.123 184.791 268.886 158.912C261.648 133.033 243.418 157.11 243.418 157.11V157.11Z",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.14 203.689C209.25 204.246 166.447 236.968 151.416 270.508C137.341 301.911 148.99 320.375 166.164 324.686C165.463 307.992 195.292 255.576 243.14 203.689Z",
    fill: "#E0CCFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M166.125 303.029C134.71 299.98 159.594 256.371 160.689 254.485C157.086 259.505 153.98 264.863 151.416 270.485C137.341 301.888 148.99 320.352 166.164 324.664C165.969 319.985 168.172 312.497 172.505 302.968C170.386 303.211 168.248 303.232 166.125 303.029Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.14 203.689C209.25 204.246 166.447 236.968 151.416 270.508C137.341 301.911 148.99 320.375 166.164 324.686C165.463 307.992 195.292 255.576 243.14 203.689Z",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.09 205.152C272.09 205.152 275.951 233.14 256.118 234.815C236.286 236.489 239.101 210.07 239.101 210.07",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.641 212.59C243.393 212.694 243.161 212.83 242.951 212.996C220.615 226.737 231.452 266.201 209.656 304.058C199.47 321.743 180.8 328.358 166.153 324.686C165.452 307.997 173.385 263.709 221.227 211.8C225.861 206.793 230.684 202.899 236.192 197.776C241.899 191.99 235.635 203.595 237.939 202.343C240.242 201.091 245.655 198.96 248.508 199.239C251.362 199.517 243.151 203.689 243.151 203.689C243.151 203.689 251.262 199.795 251.724 201.291C252.002 202.204 248.141 204.423 246.005 205.347C244.575 205.97 243.357 206.404 243.357 206.404C243.635 206.337 250.767 204.868 250.895 206.154C251.023 207.439 243.691 209.397 243.691 209.397C243.691 209.397 254.11 207.717 243.641 212.59Z",
    fill: "#F985C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M243.679 209.375C243.679 209.375 251.011 207.422 250.884 206.131C250.868 206.034 250.814 205.948 250.733 205.892C245.727 206.855 230.651 211.555 221.01 233.941C209.622 260.371 198.808 303.78 168.606 303.168C166.503 312.403 165.958 319.74 166.163 324.664C180.811 328.335 199.481 321.721 209.667 304.036C231.463 266.207 220.626 226.709 242.962 212.974C243.17 212.817 243.398 212.688 243.64 212.59C254.11 207.717 243.679 209.375 243.679 209.375Z",
    fill: "#F743AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.641 212.59C243.393 212.694 243.161 212.83 242.951 212.996C220.615 226.737 231.452 266.201 209.656 304.058C199.47 321.743 180.8 328.358 166.153 324.686C165.452 307.997 173.385 263.709 221.227 211.8C225.861 206.793 230.684 202.899 236.192 197.776C241.899 191.99 235.635 203.595 237.939 202.343C240.242 201.091 245.655 198.96 248.508 199.239C251.362 199.517 243.151 203.689 243.151 203.689C243.151 203.689 251.262 199.795 251.724 201.291C252.002 202.204 248.141 204.423 246.005 205.347C244.575 205.97 243.357 206.404 243.357 206.404C243.635 206.337 250.767 204.868 250.895 206.154C251.023 207.439 243.691 209.397 243.691 209.397C243.691 209.397 254.11 207.717 243.641 212.59V212.59Z",
    stroke: "#42307D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.364 330.527C302.364 330.527 319.899 301.299 315.716 277.077C305.491 276.66 202.98 277.077 202.98 277.077C202.98 277.077 204.02 311.318 219.474 328.647C239.935 332.83 302.364 330.527 302.364 330.527Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M315.721 277.088C312.383 276.955 299.104 276.905 282.782 276.905C292.941 278.857 308.183 283.241 308.278 291.97C308.417 305.065 289.625 298.59 291.088 311.44C292.551 324.291 225.633 315.646 219.285 327.479C219.172 327.692 219.087 327.918 219.03 328.152C219.18 328.324 219.324 328.497 219.48 328.669C226.79 330.16 239.457 330.828 252.72 331.067C274.11 329.576 298.459 327.089 302.376 330.511C302.643 330.066 319.855 301.121 315.721 277.088Z",
    fill: "#5E41A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.364 330.527C302.364 330.527 319.899 301.299 315.716 277.077C305.491 276.66 202.98 277.077 202.98 277.077C202.98 277.077 204.02 311.318 219.474 328.647C239.935 332.83 302.364 330.527 302.364 330.527V330.527Z",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.977 114.241C256.542 114.241 258.622 112.161 258.622 109.595C258.622 107.03 256.542 104.95 253.977 104.95C251.411 104.95 249.332 107.03 249.332 109.595C249.332 112.161 251.411 114.241 253.977 114.241Z",
    fill: "#42307D",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.348,
    y: 327.095,
    width: 90.1941,
    height: 9.59074,
    rx: 4.79537,
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M219.03 336.19C219.685 336.514 220.407 336.683 221.138 336.685H301.741C304.39 336.685 306.537 334.539 306.537 331.89C306.537 329.242 304.39 327.095 301.741 327.095H282.148C288.045 328.04 298.654 327.562 296.462 332.413C294.849 335.985 221.655 329.882 219.03 336.19H219.03Z",
    fill: "#6746B4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.348,
    y: 327.095,
    width: 90.1941,
    height: 9.59074,
    rx: 4.79537,
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.4 175.69C270.421 161.426 265.409 161.148 265.837 164.625C266.266 168.102 268.48 176.308 265.837 173.815C263.946 172.019 261.765 163.301 260.68 158.495C260.518 157.782 260.033 157.186 259.369 156.883C258.704 156.58 257.936 156.604 257.292 156.948C251.907 159.802 239.24 164.447 226.167 154.328C208.921 140.977 226.445 117.723 239.112 124.404C251.779 131.085 251.501 145.421 260.808 136.376C270.115 127.33 280.279 125.378 284.173 135.397C288.067 145.416 270.671 158.089 279.723 159.874C280.157 159.941 285.742 160.458 284.173 165.237C282.604 170.016 276.34 172.625 279.995 174.922C283.65 177.22 273.403 183.796 271.378 180.296C271.361 177.965 271.4 175.69 271.4 175.69Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.201 135.397C281.792 129.216 277.002 127.609 271.495 129.383C275.773 129.483 281.008 130.763 281.069 136.376C281.169 145.872 268.229 145.349 270.733 153.388C273.236 161.427 266.243 162.261 264.992 157.877C263.74 153.494 257.893 151.268 252.258 155.146C246.622 159.023 239.657 160.353 230.623 157.243C242.033 163.396 252.514 159.468 257.281 156.948C257.925 156.604 258.693 156.58 259.358 156.883C260.022 157.187 260.507 157.783 260.669 158.495C261.754 163.301 263.935 172.019 265.826 173.816C268.469 176.319 266.243 168.108 265.826 164.625C265.409 161.143 270.421 161.427 271.389 175.69C271.389 175.69 271.35 177.966 271.389 180.319C273.414 183.818 283.661 177.242 280.006 174.945C276.352 172.647 282.616 170.038 284.184 165.26C285.753 160.481 280.162 159.963 279.734 159.897C270.699 158.072 288.095 145.422 284.201 135.397Z",
    fill: "#5E41A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.4 175.69C270.421 161.426 265.409 161.148 265.837 164.625C266.266 168.102 268.48 176.308 265.837 173.815C263.946 172.019 261.765 163.301 260.68 158.495C260.518 157.782 260.033 157.186 259.369 156.883C258.704 156.58 257.936 156.604 257.292 156.948C251.907 159.802 239.24 164.447 226.167 154.328C208.921 140.977 226.445 117.723 239.112 124.404C251.779 131.085 251.501 145.421 260.808 136.376C270.115 127.33 280.279 125.378 284.173 135.397C288.067 145.416 270.671 158.089 279.723 159.874C280.157 159.941 285.742 160.458 284.173 165.237C282.604 170.016 276.34 172.625 279.995 174.922C283.65 177.22 273.403 183.796 271.378 180.296C271.361 177.965 271.4 175.69 271.4 175.69V175.69Z",
    stroke: "#42307D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.718,
    cy: 303.247,
    r: 11.3657,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.966 184.279C247.966 184.279 249.787 185.676 251.96 184L247.966 184.279Z",
    fill: "#F985C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.966 184.279C247.966 184.279 249.787 185.676 251.96 184",
    stroke: "#42307D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.983 58.6145H308",
    stroke: "#42307D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.864 27.7575L298.669 15.1409",
    stroke: "#42307D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.421 93.4513L279.612 80.8308",
    stroke: "#42307D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.179 58.6145H198.162",
    stroke: "#42307D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.298 27.7575L207.493 15.1409",
    stroke: "#42307D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.741 93.4513L226.55 80.8308",
    stroke: "#42307D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.345 16.8721V3.05176e-05",
    stroke: "#42307D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M362.306 399.71C362.674 399.409 363.035 399.109 363.386 398.808C363.603 398.625 363.808 398.441 364.014 398.252C364.32 397.98 364.621 397.696 364.915 397.44L365.544 396.85C365.817 396.594 366.1 396.338 366.334 396.083L366.952 395.465C367.191 395.22 367.419 394.97 367.652 394.725C367.886 394.48 368.047 394.302 368.237 394.091C368.426 393.88 368.643 393.624 368.843 393.39C369.249 392.923 369.638 392.45 370.006 391.983L370.384 391.504C370.601 391.215 370.807 390.948 371.013 390.642L371.341 390.186C371.547 389.885 371.741 389.59 371.93 389.296L372.192 388.889C372.392 388.572 372.581 388.261 372.748 387.949L372.926 387.638C373.121 387.298 373.31 386.954 373.483 386.609L373.516 386.542C374.328 384.998 374.988 383.379 375.485 381.708C369.266 384.211 361.394 385.93 351.453 386.486C309.001 388.867 257.148 357.397 210.635 346.243C185.367 338.082 161.618 339.322 148.178 343.684C139.872 351.311 138.003 357.035 148.484 350.994C169.93 338.666 183.403 344.53 186.535 347.45C189.667 350.371 192.872 353.013 196.076 355.628C224.37 378.648 254.538 392.5 283.016 399.409L283.199 399.454C283.995 399.648 284.79 399.832 285.586 400.01L285.931 400.088L288.201 400.589L288.646 400.689L290.832 401.139L291.355 401.24C292.061 401.384 292.768 401.518 293.469 401.651L294.025 401.757L296.089 402.124L296.695 402.23L298.72 402.564L299.355 402.658L301.357 402.959L301.98 403.048C302.648 403.142 303.315 403.237 303.978 403.32L304.578 403.398L306.587 403.648L307.143 403.71L309.19 403.932L309.63 403.977L311.777 404.177H311.949C315.169 404.459 318.347 404.653 321.484 404.761H321.768L323.521 404.811H324.288H325.846H326.781H329.256H330.63H331.704L333.022 404.772L334.135 404.733L335.403 404.677L336.516 404.622L337.745 404.55L338.897 404.477L340.087 404.388L341.256 404.299L342.407 404.194L343.587 404.082L344.699 403.971L345.884 403.837L346.997 403.71L348.182 403.559L349.239 403.42L350.44 403.248L351.458 403.098C351.87 403.036 352.276 402.964 352.688 402.897L353.645 402.742L354.924 402.519L355.803 402.358L357.216 402.085L357.928 401.946C358.629 401.801 359.33 401.657 360.025 401.501C360.626 401.05 361.205 400.594 361.772 400.144L362.306 399.71Z",
    fill: "#F743AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.295 140.76C222.295 140.76 222.089 132.615 226.473 129.795C230.857 126.974 223.864 136.688 227.513 136.793C231.162 136.899 221.878 147.647 222.295 140.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.455 131.469C229.455 131.469 231.585 127.831 233.349 129.283C235.112 130.735 228.782 134.707 229.455 131.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.623 205.914C230.623 205.914 219.463 213.641 218.94 219.594C218.417 225.546 225.833 211.027 227.285 212.751C228.737 214.476 233.655 203.572 230.623 205.914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.793 221.013C216.793 221.013 213.005 224.79 213.216 226.359C213.427 227.927 218.924 222.898 216.793 221.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.111 280.532C213.111 280.532 206.635 279.697 206.741 283.77C206.846 287.842 209.856 291.497 208.927 295.358C207.998 299.218 214.991 296.537 212.693 287.909C210.396 279.28 217.6 283.564 213.111 280.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52 280.949C220.52 280.949 215.614 279.386 216.348 281.472C217.082 283.558 223.129 284.398 220.52 280.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.344 316.441C147.344 316.441 122.31 316.441 114.36 322.705C106.411 328.969 123.144 326.466 127.573 322.705C132.001 318.945 155.594 317.281 147.344 316.441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.529 329.598C108.96 328.09 105.682 328.615 103.713 330.85C99.9519 334.711 117.153 333.353 111.529 329.598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.102 333.181C174.102 333.181 184.672 327.813 186.491 331.056C188.31 334.299 172.016 335.962 174.102 333.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.829 331.084C189.829 331.084 193.59 330.149 192.755 333.07C191.921 335.99 187.186 331.851 189.829 331.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.549 296.592C319.549 296.592 330.675 295.619 330.675 298.54C330.675 301.46 319.855 298.161 320.806 301.599C321.757 305.037 313.986 298.261 319.549 296.592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.235 329.292C223.235 329.292 218.646 329.292 218.229 332.302C217.811 335.312 230.323 329.048 222.835 330.016",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3859 342.209C95.1175 347.094 94.5501 353.408 96.9923 359.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8881 337.625C97.6377 338.248 97.3874 338.916 97.1482 339.639",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.058 333.164C99.5902 333.949 99.1649 334.759 98.7837 335.589",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.708 277.166C182.308 278.278 181.94 279.391 181.595 280.465",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.737 239.292C197.906 247.771 189.74 260.532 184.677 272.22",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.824 234.886L205.533 236.717",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.679 229.629C210.679 229.629 209.978 230.542 208.788 232.172",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.849 132.231C275.379 132.022 275.957 131.962 276.518 132.059",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.787 133.105C246.62 135.174 248.15 137.492 249.332 139.992C253.682 148.893 265.047 137.967 272.085 133.627",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.888 130.445C242.333 130.779 242.795 131.157 243.268 131.586",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.442 127.881C237.276 128.024 238.086 128.28 238.851 128.643",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.052 218.587C248.875 221.24 250.567 224.15 253.993 223.833",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.29 214.592C247.342 215.27 247.433 215.944 247.562 216.612",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.644 280.465H261.442",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.866 280.465H233.622",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.348 280.465H226.94",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.835 329.292H264.992",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.909 329.292H235.902",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.718 329.292H229.455",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.195 300.136C345.534 301.627 350.991 304.03 355.18 307.568",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.885 298.105C333.885 298.105 335.287 298.372 337.462 298.979",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.014 333.787C360.014 333.787 365.505 333.409 369.004 324.986C372.504 316.564 373.928 333.02 367.803 338.082C361.678 343.144 355.063 336.419 360.014 333.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.605 332.947C373.605 332.947 370.59 338.132 372.131 338.477C373.672 338.822 376.554 332.041 373.605 332.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.008 341.437C352.431 341.046 353.819 340.538 355.158 339.918",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.007 343.1C343.793 342.894 345.517 342.638 347.153 342.332",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.357 343.228C315.643 343.678 327.376 344.268 337.996 343.473",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.762 342.855L306.542 343.011",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.068 343.945C152.389 344.457 151.699 344.999 150.999 345.57",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.951 335.406C168.951 335.406 163.465 336.63 155.354 342.282",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.412 289.227C362.935 290.796 363.449 292.422 363.953 294.106",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.319 280.805C359.786 281.958 360.248 283.148 360.704 284.376",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.462 248.8C337.462 248.8 348.321 255.209 358.162 278.023",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.537 218.181C269.375 218.865 269.18 219.572 268.98 220.301",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.004 207.522C270.004 207.522 270.766 210.487 270.093 215.277",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.667 312.247C198.097 311.775 198.502 311.281 198.88 310.767",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.513 314.978C195.069 314.589 195.626 314.177 196.115 313.738",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.016 321.482C172.016 321.482 182.808 321.243 191.392 316.854",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.345 369.814C401.348 375.104 397.081 380.801 388.586 385.652",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.864 359.895C404.952 361.567 404.872 363.245 404.625 364.901",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.34 352.529C403.758 353.572 404.082 354.65 404.308 355.75",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.306 324.664C399.306 324.664 417.108 335.879 418.51 355.756",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.826 244.244C158.826 244.244 135.967 267.247 139.583 297.093",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5171 346.66C82.5171 346.66 84.0803 373.663 103.201 383.961",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.366 215.605C316.366 215.605 331.103 225.035 333.885 229.63",
    stroke: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.983 169.644C258.858 169.644 259.568 168.934 259.568 168.059C259.568 167.183 258.858 166.473 257.983 166.473C257.107 166.473 256.397 167.183 256.397 168.059C256.397 168.934 257.107 169.644 257.983 169.644Z",
    fill: "#42307D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.585 169.171C246.461 169.171 247.171 168.461 247.171 167.585C247.171 166.71 246.461 166 245.585 166C244.71 166 244 166.71 244 167.585C244 168.461 244.71 169.171 245.585 169.171Z",
    fill: "#42307D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_130_17414",
    x1: 237.189,
    y1: 36.566,
    x2: 279.574,
    y2: 90.4996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F56D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C177FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_130_17414",
    x1: 267.5,
    y1: 81,
    x2: 64.5298,
    y2: 329.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4EAFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_130_17414",
    x1: 90.3527,
    y1: 256.677,
    x2: 7.52615,
    y2: 355.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4EAFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_17414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 515,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingIcn);
export default __webpack_public_path__ + "static/media/tracking-icn.82c0bf1862995d68c0fccaf25c578f29.svg";
export { ForwardRef as ReactComponent };